import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import {
  setToken,
  getToken,
  setTitle,
  setCurrentType,
  getCurrentType
} from '@/libs/util'
import { handleExternalLogin } from '@/libs/tools'
import config from '@/config'
const {
  HOME_PAGES,
  LOGIN_PAGES,
  REGISTER_PAGES,
  WHITE_LIST
} = config

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  console.log('to', to)
  handleExternalLogin(to, next)
  // 获取当前类型，并根据类型获取对应页面
  let CURRENT_TYPE = getCurrentType()
  let HOME_PAGE_NAME = HOME_PAGES[CURRENT_TYPE]
  let LOGIN_PAGE_NAME = LOGIN_PAGES[CURRENT_TYPE]
  let REGISTER_PAGE_NAME = REGISTER_PAGES[CURRENT_TYPE]
  // 初始differ：表示如果是登录或注册页面，跳转的type和当前对应类型是否有区别
  let differ = false
  if (to.meta.type) {
    differ = CURRENT_TYPE !== to.meta.type
    CURRENT_TYPE = to.meta.type
    setCurrentType(CURRENT_TYPE)
    HOME_PAGE_NAME = HOME_PAGES[CURRENT_TYPE]
    LOGIN_PAGE_NAME = LOGIN_PAGES[CURRENT_TYPE]
    REGISTER_PAGE_NAME = REGISTER_PAGES[CURRENT_TYPE]
  }
  console.log('differ', differ)
  iView.LoadingBar.start()
  if (WHITE_LIST.includes(to.name)) {
    next()
  } else if (differ) {
    setToken('')
    next({
      name: LOGIN_PAGE_NAME
    })
  } else {
    const token = getToken()
    // 没有token，跳转页面不是登录页
    if (!token && (to.name !== LOGIN_PAGE_NAME && to.name !== REGISTER_PAGE_NAME)) {
      // 未登录且要跳转的页面不是登录且注册
      next({
        name: LOGIN_PAGE_NAME // 跳转到登录页
      })
    } else if (!token && (to.name === LOGIN_PAGE_NAME || to.name === REGISTER_PAGE_NAME)) {
      // 未登录且要跳转的页面是登录页或注册
      next() // 跳转
    } else if (token && (to.name === LOGIN_PAGE_NAME || to.name === REGISTER_PAGE_NAME)) {
      // 已登录且要跳转的页面是登录页else {
      next({
        name: HOME_PAGE_NAME // 跳转到homeName页
      })
    } else {
      if (store.state.user.hasGetInfo) {
        next()
      } else {
        store.dispatch('getUserInfo').then(() => {
          next()
        }).catch(() => {
          setToken('')
          next({
            name: LOGIN_PAGE_NAME
          })
        })
      }
    }
  }

})

router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router